import { connect } from "react-redux";
import { DesignChapter } from "@learningblocks/storybook-components";

import { getIsModalOpen } from "./TechniqueViewComplete.selector";
import { getNextMenuValue } from "../../NotebookExpDesignWeb/NotebookExpDesignWeb.selector";
import { setChapter, viewFourComplete } from "@learningblocks/exp-redux";

function mapStateToProps(state) {
  return {
    isOpen: getIsModalOpen(state),
    nextMenuValue: getNextMenuValue(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onClickNext: (params) => {
      dispatch(viewFourComplete());
      dispatch(setChapter(params));
    }
  };
}

export const TechniqueViewComplete = connect(
  mapStateToProps,
  mapDispatchToProps
)(DesignChapter.TechniqueViewComplete);
